module.exports = __webpack_public_path__ + "static/media/0021_IMG_LES_MURS_P21_UNI_PERGAMON_HORIZONTAL.cd0da4a8.webp";